import React, { useState, useEffect } from 'react';

interface SimpleCaptchaProps {
  onValidate: (isValid: boolean) => void;
  onChange?: (isValid: boolean) => void;
  onExpired?: () => void;
  theme?: string;
}

const SimpleCaptcha: React.FC<SimpleCaptchaProps> = ({ onValidate }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [isValid, setIsValid] = useState(false);

  // Generate random numbers on mount
  useEffect(() => {
    generateNewChallenge();
  }, []);

  // Validate answer
  useEffect(() => {
    const correctAnswer = num1 + num2;
    const parsed = parseInt(userAnswer, 10);
    const valid = userAnswer.trim() !== '' && !Number.isNaN(parsed) && parsed === correctAnswer;
    setIsValid(valid);
    onValidate(valid);
  }, [userAnswer, num1, num2, onValidate]);

  const generateNewChallenge = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setUserAnswer('');
    setIsValid(false);
    onValidate(false);
  };

  return (
    <div className="bg-gray-700/30 rounded p-4 min-w-0 overflow-x-hidden">
      <div className="flex items-center space-x-3 min-w-0">
        <div className="flex-1 min-w-0">
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Security check: What is {num1} + {num2}?
          </label>
          <div className="flex items-center space-x-2 min-w-0">
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="off"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value.replace(/\D/g, ''))}
              placeholder="Your answer"
              className={`flex-1 min-w-0 max-w-full box-border px-4 py-2 bg-gray-700 border rounded-md text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 ${isValid ? 'border-green-500' : 'border-gray-600'}`}
            />
            {isValid && (
              <svg className="w-6 h-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
        </div>
        <button
          type="button"
          onClick={generateNewChallenge}
          className="mt-6 p-2 text-gray-400 hover:text-white transition-colors"
          title="New challenge"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SimpleCaptcha;
